import { generatePath, useLocation, useNavigate, useParams } from 'react-router';
import { isLanguageSupported } from '../utils/isLanguageSupported';
import { SupportedLanguages } from '../types';
import { COUNTRY_TO_LANG } from '../config';
import { LANG_PARAM } from 'src/router/hooks';

/**
 * Хук возвращает функцию, которая может изменить язык в текущем URL.
 * Используется для подстановки или замены кода языка в URL при смене языка.
 *
 * Пример использования:
 *   const setLanguageToUrl = useSetLanguageToUrl();
 *   setLanguageToUrl('de');
 */
export const useSetLanguageToUrl = (): ((lang: SupportedLanguages) => void) => {
  const { pathname, search, state } = useLocation();
  const navigate = useNavigate();
  const { lang: langFromUrl } = useParams();

  return (language: SupportedLanguages) => {
    if (!language || !isLanguageSupported(language)) {
      navigate(decodeURIComponent(pathname).replace(language, ''));
    }

    const lang = language === COUNTRY_TO_LANG.EN ? '' : language;

    const newPath = generatePath(
      LANG_PARAM + decodeURIComponent(pathname).replace(langFromUrl || '', ''),
      { lang }
    );

    navigate(newPath + search, { state, replace: true });
  };
};
